//When we disable the search criteria, it should also reset these search criteria value.
//This file is to keep mapping between the search criteria checkbox value and related field
//when disable 'coVslVoy', we need to clear field 'co','vsl','voy'

export const ManChargeHdrSearchCriteriaCheckboxRelatedField: { [key: string]: string[] } = {
    coVslVoy: ['co', 'vsl', 'voy'],
    opsDate: ['opsDateFrom', 'opsDateTo'],
    createdDate: ['createdDateFrom', 'createdDateTo'],
}